/**
 * Resolve student prompt/schema values for display, mirroring backend
 * ``DistillationEvent.resolved_student_*`` inheritance from the usecase.
 */

import { effectiveTeacherSchemaForStudent } from './supportsJsonSchema';

function resolveField(overrideValue, teacherValue) {
    const override = overrideValue != null && String(overrideValue).trim() !== ''
        ? String(overrideValue)
        : '';
    return override || teacherValue || '';
}

function resolveSchemaField(overrideValue, teacherValue) {
    if (overrideValue != null) {
        return String(overrideValue).trim();
    }
    return (teacherValue || '').trim();
}

/**
 * @param {Object|null} usecase Current task configuration.
 * @param {Object} [options]
 * @param {boolean} [options.includeSchema=true] When false, schema is omitted (flag off).
 * @param {Object} [options.availableProviders] When set, inherited teacher schema is gated
 *   on whether the teacher model supports JSON schema.
 * @returns {{ system: string, user: string, schema: string }}
 */
export function resolveStudentFields(usecase, { includeSchema = true, availableProviders } = {}) {
    const system = resolveField(
        usecase?.generative_student_instructions,
        usecase?.teacher_system_prompt,
    );
    const user = resolveField(
        usecase?.generative_student_prompt,
        usecase?.prompt,
    );
    const inheritedTeacherSchema = availableProviders != null
        ? effectiveTeacherSchemaForStudent({
            teacherSchema: usecase?.teacher_schema,
            provider: usecase?.teacher_provider,
            modelId: usecase?.teacher_model,
            availableProviders,
        })
        : (usecase?.teacher_schema || '').trim();
    const schema = includeSchema
        ? resolveSchemaField(usecase?.generative_schema, inheritedTeacherSchema)
        : '';
    return { system, user, schema };
}

export { resolveField, resolveSchemaField };
